import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import { CommonLibrary } from "../../../contexts/CommonContext";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter  
} from "@progress/kendo-react-grid";

import { ODataProvider } from "../../../contexts/ODataContext";
import { RoleService } from "../../../services/RoleService";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";
import { Link, useLocation } from "react-router-dom";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import Modal from 'react-bootstrap/Modal';


const ManagePermissions: React.FC = () => {

  const roleService = new RoleService();
  const commonLibrary = new CommonLibrary();
  const { t } = useTranslation();
  const location = useLocation();
  const { RoleId, Description } = location.state as any;
  const permissionsApi = config.API_URL + "/odata/Permissions/";
  const rolePermissionsApi = config.API_URL + "/odata/ProjectRolePermissions/";
  const dataGridPermissionsRef = useRef<DataGridHandle>(null);
  const dataGridRolePermissionsRef = useRef<DataGridHandle>(null);
  const [selectedPermissionsItems, setSelectedPermissionItems] = React.useState<number[]>([]);
  const [selectedRolePermissionItems, setSelectedRolePermissionItems] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };
  // Define the columns
  const columnsPermissions = [] as ColumnCustomProps[];
  columnsPermissions.push({ field: "Description", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columnsPermissions.push({ field: "Area", title: t("general.area"), columnMenu: ColumnMenu, isExportable: true });
  columnsPermissions.push({ field: "Code", title: t("general.code"), columnMenu: ColumnMenu, isExportable: true });

  // Define cell read checked
  const cellReadChecked = (props: any) => (
    <td style={{ textAlign: "center" }}>
      {

        <span className="k-checkbox-wrap"><input id=":rl:" type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md" onClick={(event) => onChangeCreate(event, props.dataItem)} defaultChecked={props.dataItem.CanCreate} /></span>
        //props.dataItem.CanRead ? <span className="k-icon k-i-check"></span> : <span className="k-icon k-i-close"></span>

      }
    </td>
  );

  // Define cell edit checked
  const cellEditChecked = (props: any) => (
    <td style={{ textAlign: "center" }}>
      {
        <span className="k-checkbox-wrap"><input id=":rl:" type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md" onClick={(event) => onChangeEdit(event, props.dataItem)} defaultChecked={props.dataItem.CanEdit} /></span>
        //props.dataItem.CanEdit ? <span className="k-icon k-i-check"></span> : <span className="k-icon k-i-close"></span>
      }
    </td>
  );


  const columnsRolePermissions = [] as ColumnCustomProps[];
  columnsRolePermissions.push({ field: "Description", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columnsRolePermissions.push({ field: "Area", title: t("general.area"), columnMenu: ColumnMenu, isExportable: true });
  columnsRolePermissions.push({ field: "Code", title: t("general.code"), columnMenu: ColumnMenu, isExportable: true });
  columnsRolePermissions.push({ field: "CanCreate", title: t("general.create"), columnMenu: undefined, cell: cellReadChecked, width: "100px", isExportable: true });
  columnsRolePermissions.push({ field: "CanEdit", title: t("general.edit"), columnMenu: undefined, cell: cellEditChecked, width: "100px" , isExportable: true });


  // Define handles
  const onSelectedItemsChangeLabel = (selectedItems: number[]) => {
    setSelectedPermissionItems(selectedItems);
  }

  const onSelectedItemsChangeLabelEntity = (selectedItems: number[]) => {
    setSelectedRolePermissionItems(selectedItems);
  }

  // Define onchange event for checkbox read
  const onChangeCreate = (event: any, data: any) => {   
    const rolePermissionModel = {
      RoleId: RoleId,
      PermissionId: data.PermissionId,
      CanCreate: !data.CanCreate,
      CanEdit: data.CanEdit
    };

    roleService.UpdatePermissionForRole(rolePermissionModel).then(() => {
      dataGridRolePermissionsRef.current?.refreshData();
    });
  }

  // Define onchange event for checkbox edit
  const onChangeEdit = (event: any, data: any) => {
    const rolePermissionModel = {
      RoleId: RoleId,
      PermissionId: data.PermissionId,
      CanCreate: data.CanCreate,
      CanEdit: !data.CanEdit
    };

    roleService.UpdatePermissionForRole(rolePermissionModel).then(() => {
      dataGridRolePermissionsRef.current?.refreshData();
    });
  }

  React.useEffect(() => {
    dataGridRolePermissionsRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "RoleId",
          operator: "eq",
          value: RoleId
        }
      ]
    });
  }, []);

  const handleAddPermissionsToRole = () => {
    if (selectedPermissionsItems.length > 0) {
      const roleModel = {
        ProjectId: commonLibrary.ProjectId,
        TargetId: RoleId,
        ObjectIds: selectedPermissionsItems
      };
      roleService.AddPermissionsToRole(roleModel).then(() => {
        dataGridRolePermissionsRef.current?.refreshData();
      });
    }
  }

  const handleRemovePermissionsFromRole = () => {
    if (selectedRolePermissionItems.length > 0) {
      setShow(true);
    }
  }

  const handleConfirm = () => {
    setShow(false);
    const roleModel = {
      ProjectId: commonLibrary.ProjectId,
      TargetId: RoleId,
      ObjectIds: selectedRolePermissionItems
    };
    roleService.RemovePermissionsFromRole(roleModel).then(() => {
      dataGridRolePermissionsRef.current?.refreshData();
    });
  }


  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/roles">
             <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">         
            <h5 className="title"><Trans>configuration.roles.managePermissionsTo</Trans> {Description}</h5>
            <span className="subtitle"><Trans>configuration.roles.permissionManagementSubtitle</Trans></span>      
            <Row className="pt-2">
            <Col sm={12} className="content-labels">     
          <ODataProvider baseUrl={permissionsApi} loadingContent=".content-labels .k-grid-content">
            <DataGridCustom ref={dataGridPermissionsRef} DataItemKey="Id" Columns={columnsPermissions} onSelectedItemsChange={onSelectedItemsChangeLabel} PageSize={6}/>
          </ODataProvider>
          </Col>
          </Row>
        </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">    
        <span className="subtitle"><Trans>configuration.roles.permissionManagementSubtitleSettings</Trans></span>
      <Row className="content-entity-labels">
        <Col sm={12}>
          <ODataProvider baseUrl={rolePermissionsApi} loadingContent=".content-entity-labels .k-grid-content">
            <DataGridCustom PermissionButtonCode="configuration_roles_permissions" ShowAddButton={true} ShowRemoveButton={true} onAddButtonClick={handleAddPermissionsToRole} onRemoveButtonClick={handleRemovePermissionsFromRole} ref={dataGridRolePermissionsRef} DataItemKey="PermissionId" Columns={columnsRolePermissions} onSelectedItemsChange={onSelectedItemsChangeLabelEntity} PageSize={6}/>
          </ODataProvider>
        </Col>
      </Row>
      </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><Trans>general.titleRemoveMessage</Trans></Modal.Title>
        </Modal.Header>
        <Modal.Body><Trans>general.removeMessage</Trans></Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={handleClose}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
            <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManagePermissions;
